import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Header({ minimal = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-forge-900/85 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="header-logo">
          <span className="inline-block w-1.5 h-6 bg-ember-500 animate-ember-glow"></span>
          <span className="font-serif text-2xl tracking-tight text-forge-100 group-hover:text-ember-400 transition-colors">
            ThoughtSmith™
          </span>
        </Link>
        {!minimal && (
          <nav className="flex items-center gap-2 sm:gap-6 text-sm">
            {user ? (
              <>
                <Link to="/dashboard" className="hidden sm:inline text-forge-100/70 hover:text-ember-400 transition-colors" data-testid="nav-dashboard">Dashboard</Link>
                <Link to="/learn" className="hidden sm:inline text-forge-100/70 hover:text-ember-400 transition-colors" data-testid="nav-learn">Learn</Link>
                <Link to="/research" className="hidden md:inline text-forge-100/70 hover:text-ember-400 transition-colors" data-testid="nav-research">Research</Link>
                <Link to="/writing" className="hidden md:inline text-forge-100/70 hover:text-ember-400 transition-colors" data-testid="nav-writing">Writing</Link>
                <Link to="/journal" className="hidden md:inline text-forge-100/70 hover:text-ember-400 transition-colors" data-testid="nav-journal">Journal</Link>
                <Link to="/progress" className="hidden sm:inline text-forge-100/70 hover:text-ember-400 transition-colors" data-testid="nav-progress">Progress</Link>
                {(user.role === "teacher" || user.role === "admin") ? (
                  <Link to="/teacher" className="hidden md:inline text-gold-500 hover:text-gold-400 transition-colors" data-testid="nav-teacher">Teacher</Link>
                ) : (
                  <Link to="/join-class" className="hidden md:inline text-forge-100/70 hover:text-ember-400 transition-colors" data-testid="nav-join-class">Join Class</Link>
                )}
                {user.role !== "teacher" && user.role !== "admin" && !user.institution_id && (
                  <Link to="/join-institution" className="hidden lg:inline text-forge-100/70 hover:text-ember-400 transition-colors" data-testid="nav-join-institution">Join Institution</Link>
                )}
                {user.role === "admin" && (
                  <Link to="/admin" className="hidden md:inline text-gold-500 hover:text-gold-400 transition-colors" data-testid="nav-admin">Admin</Link>
                )}
                <span className="hidden md:inline text-xs uppercase tracking-[0.25em] text-forge-100/40">{user.name || user.email}</span>
                <button
                  onClick={async () => { await logout(); navigate("/"); }}
                  className="text-xs uppercase tracking-[0.2em] text-forge-100/60 hover:text-ember-400 transition-colors"
                  data-testid="nav-logout"
                >
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/auth"
                className="text-xs uppercase tracking-[0.2em] px-4 py-2 border border-white/15 hover:border-ember-500 hover:text-ember-400 transition-all rounded-sm"
                data-testid="nav-signin"
              >
                Sign in
              </Link>
            )}
          </nav>
        )}
      </div>
    </header>
  );
}
